'use client';
import { useState, useRef, useEffect } from 'react';
import { useReducedMotion } from '@s7/hooks';

function useShouldLockScroll(options) {
    const { opened, transitionDuration, lockScroll } = options;
    const [shouldLock, setShouldLock] = useState(opened);
    const reduceMotion = useReducedMotion();
    const timeout = useRef();
    useEffect(()=>{
        if (!lockScroll) {
            if (shouldLock) {
                setShouldLock(false);
            }
            return;
        }
        const _transitionDuration = reduceMotion ? 0 : transitionDuration;
        if (opened) {
            setShouldLock(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) {
            setShouldLock(false);
        } else {
            timeout.current = window.setTimeout(()=>setShouldLock(false), _transitionDuration);
        }
        return ()=>window.clearTimeout(timeout.current);
    }, [
        opened,
        transitionDuration,
        reduceMotion,
        lockScroll
    ]);
    return shouldLock;
}

export { useShouldLockScroll };
//# sourceMappingURL=useShouldLockScroll.js.map
